import React from "react";

import { Link } from "../Link";

import "./NavList.scss";

export type NavListProps = {
  cx?: string;
  list: { link?: string; href?: string; text: string }[];
  current: string;
  routerLink: any;
};

/**
 *
 * @param cx
 * @param list - link는 내부 라우터 사용, href는 a href태그임.
 * @param current
 * @param routerLink
 * @constructor
 */
export const NavList: React.FC<NavListProps> = ({
  cx = "",
  list,
  current,
  routerLink,
}) => {
  return (
    <nav className={`NavList ${cx}`}>
      {list.map(({ link, href, text }, idx) =>
        !!link ? (
          <Link
            to={link}
            key={`${text}-${idx}`}
            routerLink={routerLink}
            cx={current.startsWith(link) ? "active" : ""}
          >
            {text}
          </Link>
        ) : (
          <a href={`${href}`} key={`${text}-${idx}`}>
            {text}
          </a>
        )
      )}
    </nav>
  );
};
